/** @typedef {number[]} FobIDs */

/** @type {Array<[FobIDs, string]>} */
const fobs_conf = [
  [[1], 'fob-1'],
  [[5], 'fob-2'],
  [[3], 'fob-3'],
  [[2, 9], 'fob-4'],
  [[8], 'fob-5'],
  [[4, 10], 'fob-6'],
  [[11, 12], 'fob-7']
];

/** @type {(lang: string) => number} */
export const navItemThreshold = (lang) => (lang == 'fi-FI' ? 5 : 4);

/**
 * @typedef {object} Fob
 * @property {string} id
 * @property {number} id_old
 * @property {number[]} fob_ids
 * @property {string} description
 */

/** @type {Fob[]} */
export const fobs = fobs_conf.map(([fob_ids, description], index) => ({
  id: `0${index + 1}f`, // short id to be used in URL path
  id_old: (index + 1) * 10 + 1000, // make it clear that this is not one to one with id from api
  fob_ids,
  description
}));

/** @type {Map<number | string, Fob>} */
export const fobs_map = new Map(
  fobs.reduce((acc, fob) => {
    return [...acc, [fob.id, fob], [fob.id_old, fob], [fob.description, fob]];
  }, [])
);

/** @type {Map<number, Fob>} */
export const fobs_api_map = new Map(
  fobs.reduce((acc, fob) => {
    return [...acc, ...fob.fob_ids.map((id) => [id, fob])];
  }, [])
);

/**
 * @param {ManageAPI.Store} store
 * @return {Fob}
 */
export function storeToB2cFob(store) {
  const { fieldOfBusinessId: fob_id } = store;
  return fobs_api_map.get(fob_id);
}

/**
 * @param {ManageAPI.Offer} offer
 * @param {Map<number, ManageAPI.Store>} stores_map
 * @return {Fob}
 */
export function offerToB2cFob(offer, stores_map) {
  try {
    const store = stores_map.get(offer.store.id);
    return storeToB2cFob(store);
  } catch (e) {
    console.warn(e);
    return null;
  }
}


/**
 * @param {ManageAPI.Offer[]} offers
 * @param {number} stream_id
 * @param {boolean} include_orphans - Offer is included also if it has no streams defined
 */
export function getOffersByStream(offers, stream_id, include_orphans) {
  return offers.filter((offer) => {
    const streams = offer.publicationStreams || [];
    const is_in_stream = streams.some(({ id }) => id == stream_id);
    const no_streams = !streams.length;
    return include_orphans ? is_in_stream || no_streams : is_in_stream;
  });
}

/**
 * @template T
 * @param {T[]} array
 * @param {ManageAPI.Offer} offer
 * @returns {T}
 */
export function findFirstMatchByStreams(array, offer) {
  const streams = offer.publicationStreams || [];
  return array.find((_, index) => streams.some(({ id }) => id == index));
}

/**
 * @param {string} startDate
 * @param {string} endDate
 */
export function getValidityPeriod(startDate, endDate) {
  try {
    const start_dateObj = new Date(startDate);
    const start_month = start_dateObj.getMonth() + 1; //months from 1-12
    const start_day = start_dateObj.getDate();

    const end_dateObj = new Date(endDate);
    const month = end_dateObj.getMonth() + 1; //months from 1-12
    const day = end_dateObj.getDate();
    return start_day + '.' + start_month + '.' + '-' + day + '.' + month + '.';
  } catch {
    return '';
  }
}

export function filterOffersByStream(offers, filterNames){
  if (!filterNames || !filterNames.length) return offers;

  let offers_filtered =[];
  
  const filtersCollection = [
    {name: 'BASIC', id: 1},
    {name: 'WHATS_NEW', id: 2},
    {name: 'SERVICES', id: 3},
    {name: 'RESPONSIBILITY', id: 4}
  ] 
  let filtersChosen = filtersCollection.filter(filter => filterNames.includes(filter.name))
  let filtersChosenIDS = filtersChosen.map(f => f.id);

  offers_filtered = offers.filter((offer) => {
    const streams = offer.publicationStreams || [];
    const is_in_stream = streams.some(({ id }) => filtersChosenIDS.includes(id));
    if(is_in_stream ) {
      return true;
    } else {
      return false;
    }
  });

  return offers_filtered
}
